import { render, staticRenderFns } from "./WangEditor.vue?vue&type=template&id=e88d473c&scoped=true"
import script from "./WangEditor.vue?vue&type=script&lang=js"
export * from "./WangEditor.vue?vue&type=script&lang=js"
import style0 from "./WangEditor.vue?vue&type=style&index=0&id=e88d473c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e88d473c",
  null
  
)

export default component.exports